import { Host, h, } from "@stencil/core";
import { formMessageLogic } from "../../common/form";
import { formClasses } from "../../common/classesNames";
import { commonClassesNames } from "../../common/classesNames";
import state from "../store";
import { exportParts } from "../../common/export-parts";
export class GxgFormCheckbox {
    constructor() {
        this.checkboxId = undefined;
        this.checked = false;
        this.indeterminate = false;
        this.disabled = false;
        this.label = undefined;
        this.value = undefined;
        this.name = undefined;
        this.iconName = undefined;
        this.alignTop = false;
        this.required = false;
        this.validationStatus = "indeterminate";
        this.validationMessage = undefined;
        this.informationMessage = undefined;
        this.tooltip = undefined;
    }
    parts = {
        input: "input",
    };
    exportparts;
    el;
    //A reference to the input
    checkboxInput;
    change;
    /**
     * The logic for displaying or hidding the validation messages
     *
     */
    formMessageLogic = formMessageLogic;
    /*********************************
    METHODS
    *********************************/
    componentWillLoad() {
        this.attachExportParts();
    }
    attachExportParts = () => {
        const part = this.el.getAttribute("part");
        const exportPartsResult = exportParts(part, this.parts);
        exportPartsResult.length && (this.exportparts = exportPartsResult);
    };
    compontentDidLoad() {
        if (this.checked && this.disabled) {
            this.checked = false;
            this.checkboxInput.removeAttribute("checked");
        }
    }
    changed() {
        this.checked = this.checkboxInput.checked;
    }
    checkedHandler() {
        this.change.emit({
            id: this.checkboxId,
            value: this.checked,
            disabled: this.disabled,
        });
    }
    handlerOnKeyUp(event) {
        if (event.code == "Space") {
            this.checked = !this.checked;
        }
    }
    handleGxgLabelClick = () => {
        this.checkboxInput.click();
    };
    ariaChecked() {
        if (this.checked) {
            return "true";
        }
        else {
            return "false";
        }
    }
    handleInputClick(e) {
        e.stopPropagation();
    }
    icon() {
        if (this.iconName) {
            return (h("gxg-icon", { type: this.iconName, color: "auto", size: "small" }));
        }
    }
    renderCheckbox = () => {
        return [
            h("input", { ref: (el) => (this.checkboxInput = el), type: "checkbox", checked: this.checked, class: "input", id: this.checkboxId, name: this.name, value: this.value, disabled: this.disabled, onChange: this.changed.bind(this), onKeyUp: this.handlerOnKeyUp.bind(this), tabindex: "0", onClick: this.handleInputClick, part: this.parts.input }),
            h("span", { part: "box", class: {
                    box: true,
                    "no-label": !this.label,
                    "has-icon": !!this.iconName,
                    "form-element": true,
                    indeterminate: this.indeterminate,
                    checkbox: true,
                }, role: "checkbox" }),
            this.icon(),
        ];
    };
    render() {
        return (h(Host, { role: "checkbox", value: this.value, "aria-checked": this.ariaChecked, "aria-label": this.label, class: {
                large: state.large,
                [formClasses["VALIDATION_INDETERMINATE_CLASS"]]: this.validationStatus === "indeterminate",
                [formClasses["VALIDATION_WARNING_CLASS"]]: this.validationStatus === "warning",
                [formClasses["VALIDATION_ERROR_CLASS"]]: this.validationStatus === "error",
                [formClasses["VALIDATION_SUCCESS_CLASS"]]: this.validationStatus === "success",
                [commonClassesNames["DISABLED_CLASS"]]: this.disabled,
            }, exportParts: this.exportparts ? this.exportparts : null }, h("div", { class: {
                "gxg-form-checkbox__wrapper": true,
                "gxg-form-checkbox__wrapper--align-top": this.alignTop,
            }, onClick: this.handleGxgLabelClick }, this.label ? ([
            this.renderCheckbox(),
            h("gxg-label", { class: "label", disabled: this.disabled, labelPosition: "end", noMargin: true, tooltip: this.tooltip }, this.label),
        ]) : (h("div", { class: "wrapper" }, this.renderCheckbox()))), this.formMessageLogic(this)));
    }
    static get is() { return "gxg-form-checkbox"; }
    static get encapsulation() { return "shadow"; }
    static get delegatesFocus() { return true; }
    static get originalStyleUrls() {
        return {
            "$": ["form-checkbox.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["form-checkbox.css"]
        };
    }
    static get properties() {
        return {
            "checkboxId": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The checkbox id"
                },
                "attribute": "checkbox-id",
                "reflect": false
            },
            "checked": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute makes the checkbox checked by default"
                },
                "attribute": "checked",
                "reflect": false,
                "defaultValue": "false"
            },
            "indeterminate": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute makes the checkbox indeterminate"
                },
                "attribute": "indeterminate",
                "reflect": true,
                "defaultValue": "false"
            },
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute disables the checkbox"
                },
                "attribute": "disabled",
                "reflect": false,
                "defaultValue": "false"
            },
            "label": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string | undefined",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The checkbox label"
                },
                "attribute": "label",
                "reflect": false,
                "defaultValue": "undefined"
            },
            "value": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The checkbox value"
                },
                "attribute": "value",
                "reflect": false
            },
            "name": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The checkbox name"
                },
                "attribute": "name",
                "reflect": false
            },
            "iconName": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The checkbox icon"
                },
                "attribute": "icon-name",
                "reflect": false,
                "defaultValue": "undefined"
            },
            "alignTop": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Aligns the checkbox to the top of the label (useful when the label is too long)"
                },
                "attribute": "align-top",
                "reflect": false,
                "defaultValue": "false"
            },
            "required": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute makes the commbo required"
                },
                "attribute": "required",
                "reflect": true,
                "defaultValue": "false"
            },
            "validationStatus": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "ValidationStatus",
                    "resolved": "\"error\" | \"indeterminate\" | \"success\" | \"warning\"",
                    "references": {
                        "ValidationStatus": {
                            "location": "import",
                            "path": "../../common/types",
                            "id": "src/common/types.ts::ValidationStatus"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The validation status"
                },
                "attribute": "validation-status",
                "reflect": false,
                "defaultValue": "\"indeterminate\""
            },
            "validationMessage": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The message to display when validation fails (error)"
                },
                "attribute": "validation-message",
                "reflect": false
            },
            "informationMessage": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "An informative message to help the user filling the information"
                },
                "attribute": "information-message",
                "reflect": false
            },
            "tooltip": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "tooltip",
                "reflect": false
            }
        };
    }
    static get events() {
        return [{
                "method": "change",
                "name": "change",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "CheckboxInfo",
                    "resolved": "{ id: string; value: boolean; disabled?: boolean; }",
                    "references": {
                        "CheckboxInfo": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/form-checkbox/form-checkbox.tsx",
                            "id": "src/components/form-checkbox/form-checkbox.tsx::CheckboxInfo"
                        }
                    }
                }
            }];
    }
    static get elementRef() { return "el"; }
    static get watchers() {
        return [{
                "propName": "checked",
                "methodName": "checkedHandler"
            }];
    }
}
//# sourceMappingURL=form-checkbox.js.map
